export const CarouselArrow: React.FC = (props: any) => {
  const { className, style, onClick } = props;

  // We do this so we can add stopNavigation, which prevents bubbling
  // and thus gives the arrows and carousel different click functionality
  const preventBubbleClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <div
      className={className}
      style={style}
      onClick={(e) => preventBubbleClick(e)}
    />
  );
};